<template>
  <v-container class="border">
    <h2>
      <v-toolbar flat>
        <v-toolbar-title>Create Client Domain</v-toolbar-title>
        <Alert
          class="mx-4 my-2"
          v-if="showAlert"
          text="Domain created!"
          type="success"
        />
        <v-spacer></v-spacer>
      </v-toolbar>
    </h2>
    <v-form>
      <v-container class="pt-4 px-8">
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="newDomain.url"
              label="Domain name"
              required
            />
          </v-col>
          <v-col cols="4">
            <v-progress-circular
              v-if="creating"
              class="px-8"
              indeterminate
            ></v-progress-circular>
            <v-btn
              small
              @click="createClientDomain"
              class="float-sm-right mt-2 mx-2"
            >
              <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
              Create
            </v-btn>
            <v-btn small @click="cancelCreate" class="float-sm-right mt-2">
              <v-icon class="mr-1">mdi-cancel</v-icon>
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
  import Alert from '@/components/Alert.vue'

  export default {
    name: 'NewDomainContact',
    components: { Alert },
    props: {
      clientId: {
        type: String,
      },
    },
    data() {
      return {
        creating: false,
        showAlert: false,
        newDomain: {},
      }
    },
    methods: {
      cancelCreate() {
        this.$emit('cancel')
        this.newDomain = {}
      },
      createClientDomain() {
        this.creating = true
        this.apiCreateClientDomain(this.clientId, this.newDomain)
          .then(response => {
            this.$emit('domainCreated', response)
          })
          .catch(error => {
            console.log(error)
          })
        this.creating = false
        this.showAlert = true
        this.newDomain = {}
      },
    },
  }
</script>
